// import menuInit from './menu';
// import navbarInit from './navbar';
import mobileInit from './mobile';

window.onload = async () => {
  if (document.getElementsByClassName('slider').length) {
    import('./slider').then((module) => {
      document.querySelectorAll('.slider .slider__swiper').forEach((slide : HTMLElement) => {
        module.default(slide);
      });
    });
  }
  if (document.getElementsByClassName('upload').length) {
    import('./upload').then((module) => module.default());
  }
  if (document.getElementsByClassName('header-main').length) {
    import('./header').then((module) => module.default());
  }
  if (document.getElementsByClassName('posts-grid').length) {
    import('./postsFilter').then((module) => module.default());
  }
  if (document.getElementsByClassName('video-highlight').length) {
    import('./videoHighlight').then((module) => module.default());
  }
  if (document.getElementsByClassName('vacancysingle__widgets').length) {
    import('./copyButton').then((module) => module.default());
  }
  if (document.getElementsByClassName('form').length) {
    import('./form').then((module) => module.default());
  }
  if (document.getElementsByClassName('vacancies-grid').length) {
    import('./vacancyLoad').then((module) => module.default());
  }
};

document.addEventListener('DOMContentLoaded', () => {
  import(/* webpackPrefetch: true */ './icons');
  mobileInit();
  // navbarInit();
  if (document.getElementsByClassName('form').length) {
    import('./form').then((module) => module.default());
  }
});

(<any>window).customGFRenderHandler = function () {
  import('./form').then((module) => module.default());
};
